export const RoutingPaths = {
  LANDING_PAGE: '/',
  VAULTS: '/vaults',
  STAKE_ADDY: '/stakeaddy',
  FURNACE: '/furnace',
  BOOST: '/boost',
};
